{
  "title": "الإيصال",
  "reprint": "إعادة طباعة",
  "print": "طباعة",
  "date": "التاريخ",
  "time": "الوقت",
  "invoiceNumber": "رقم الفاتورة",
  "kind": {
    "CASH_SALE": "بيع نقدي",
    "DEBT_SALE": "بيع ذمم",
    "PURCHASE": "شراء",
    "PAYMENT": "مدفوعات",
    "RECEIPT": "مقبوضات",
    "DEBT_REPAYMENT": "سداد ذمم"
  },
  "table": {
    "category": "الفئة",
    "qty": "الكمية",
    "price": "السعر"
  },
  "lessJerrycans": "إلا جركل",
  "total": "المجموع",
  "vehiclePlate": "رقم المركبة",
  "debtorName": "اسم العميل",
  "personName": "اسم الشخص",
  "statement": "البيان",
  "thankYou": "شكرا لزيارتكم",
  "pricePending": "بانتظار التسعير"
}
